import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlowLandingPageComponent } from './components/flow-landing-page/flow-landing-page.component';
import { FlowLeftInputsComponent } from './components/flow-left-inputs/flow-left-inputs.component';
import { FlowRightSectionComponent } from './components/flow-right-section/flow-right-section.component';
import { FlowHeaderComponent } from './components/flow-header/flow-header.component';
import { FlowBottomAreaComponent } from './components/flow-bottom-area/flow-bottom-area.component';
import { RouterModule, Routes } from '@angular/router';
import { FlowBuilderOverviewComponent } from './flow-builder-overview/flow-builder-overview.component';
import { MatMenuModule } from '@angular/material/menu';
import { TopActionAreaComponent } from './sections/top-action-area/top-action-area.component';
import { SelectNodeComponent } from './sections/select-node/select-node.component';
import { SourceNodeComponent } from './sections/source-node/source-node.component';
import { FilterNodeComponent } from './sections/filter-node/filter-node.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TargetNodeComponent } from './sections/target-node/target-node.component';
import { JoinNodeComponent } from './sections/join-node/join-node.component';
import { PreviewSectionComponent } from './sections/preview-section/preview-section.component';
import { ToastrModule } from 'ngx-toastr';
import { SharedModule } from 'src/app/shared/shared.module';
import {MatTooltipModule} from '@angular/material/tooltip';
import { MtxTooltipModule } from '@ng-matero/extensions/tooltip';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { AutoMlComponent } from './sections/auto-ml/auto-ml.component';
import { AutoMlPreviewComponent } from './sections/auto-ml-preview/auto-ml-preview.component';
import { AutoMlOverviewComponent } from './auto-ml-overview/auto-ml-overview.component';
import { AutoMlEntryComponent } from './sections/auto-ml-entry/auto-ml-entry.component';
import { AutoMlResultsComponent } from './sections/auto-ml-results/auto-ml-results.component';
import {MatSliderModule} from '@angular/material/slider';
import { AutoMlScenarioComponent } from './sections/auto-ml-scenario/auto-ml-scenario.component';
import { TopStepperComponent } from './sections/top-stepper/top-stepper.component';
import { AutomlLoginComponent } from './automl-login/automl-login.component';
import { AutoMlInputComponent } from './sections/auto-ml-input/auto-ml-input.component';
import { FiledropDirective } from 'src/app/core/directives/filedrop.directive';


const routes: Routes = [
  {
    path: '',
    component: FlowBuilderOverviewComponent,
  },
];

@NgModule({
  declarations: [
    FlowBuilderOverviewComponent,
    FlowLandingPageComponent,
    FlowLeftInputsComponent,
    FlowRightSectionComponent,
    FlowHeaderComponent,
    FlowBottomAreaComponent,
    TopActionAreaComponent,
    SelectNodeComponent,
    SourceNodeComponent,
    FilterNodeComponent,
    TargetNodeComponent,
    JoinNodeComponent,
    PreviewSectionComponent,
    AutoMlComponent,
    AutoMlPreviewComponent,
    AutoMlOverviewComponent,
    AutoMlEntryComponent,
    AutoMlResultsComponent,
    AutoMlScenarioComponent,
    TopStepperComponent,
    AutomlLoginComponent,
    AutoMlInputComponent,
    

  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ToastrModule.forRoot({ preventDuplicates: true }),
    MatMenuModule,
    NgSelectModule,
    MatTooltipModule,
    FormsModule,
    MtxTooltipModule,
    MatTableModule,
    SharedModule,
    MatSortModule,
    MatSliderModule,
    FormsModule,
    ReactiveFormsModule,
    FiledropDirective
  ],
  exports:[
    FlowHeaderComponent
  ]
})
export class FlowBuilderModule { }
